import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "select-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "ui-select-title"
}
const _hoisted_3 = {
  key: 0,
  class: "text-danger ml-1"
}

import { computed, onMounted, PropType, ref, useSlots } from "vue";
import { UiSelectItemModel } from "./models";


export default /*#__PURE__*/_defineComponent({
  __name: 'ui-select',
  props: {
  /**
   * Значения
   */
  items: {
    type: Object as PropType<Array<UiSelectItemModel>>,
  },
  /**
   * Поле для чтения
   */
  readonly: {
    type: Boolean,
    default: false,
  },
  /**
   * Обязательно ли поле
   */
  required: {
    type: Boolean,
    default: false,
  },
  /**
   * Включена ли валидация
   */
  isValid: {
    type: Boolean,
    default: false,
  },
  /**
   * Заблокировать поле
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * Плейсхолдер
   */
  placeholder: {
    type: String,
    default: "",
  },
  /**
   * Значение
   */
  modelValue: {
    type: String,
  },
  /**
   * Параметры для валидации
   */
  params: {
    type: Object,
    default: null,
  },
  /**
   * Функция для валидации
   */
  validFunction: {
    type: Function,
    default: null,
  },
},
  emits: ["update:modelValue", "validation"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;



/**
 * События
 */


/**
 * Внутреннее значение
 */
const innerValue = ref<string>("");
/**
 * Внутренний тип поля
 */
const innerType = ref<string>("text");

/**
 * Столы
 */
const slots = useSlots();

const isPassword = ref(false);

onMounted(async () => {
  innerValue.value = props.modelValue;
});

/**
 * Значение
 */
const value = computed({
  get: () => {
    return props.modelValue == null ? innerValue.value : props.modelValue;
  },
  set: (value) => {
    emit("update:modelValue", value);
    innerValue.value = value;
  },
});

/**
 * Существуют ли слоты
 */
const hasSlot = (name: string) => {
  return !!slots[name];
};

const clickShowBtn = () => {
  innerType.value = innerType.value == "text" ? "password" : "text";
};

/**
 * Валидация
 */
const getValid = computed({
  get: () => {
    let validation = props.validFunction(value.value, props.params);
    emit("validation", validation);
    return validation;
  },
  set: () => {},
});

__expose({
  getValid,
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (hasSlot('title'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "title"),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_select, {
      class: "ui-select",
      items: __props.items,
      placeholder: __props.placeholder,
      disabled: __props.disabled,
      readonly: __props.readonly,
      error: __props.isValid && !getValid.value.IsSuccess,
      "error-messages": 
        __props.isValid && !getValid.value.IsSuccess ? getValid.value.Message : false
      ,
      "menu-icon": "mdi-chevron-down",
      "item-value": "Id",
      "item-title": "Text",
      variant: "outlined",
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      "max-height": "500"
    }, null, 8, ["items", "placeholder", "disabled", "readonly", "error", "error-messages", "modelValue"])
  ]))
}
}

})